<span class="flex-none fc-400 flex items-center justify-center">
	<ng-content select="[icon]"></ng-content>
</span>

<span class="wrapper-content px-2 flex-auto truncate flex items-center justify-start box-border">
	<ng-content></ng-content>
</span>

<span
	class="flex-auto truncate fc-400 flex flex-row items-center justify-end grow-2 shrink-0"

>
	<ng-content select="[value]"></ng-content>
</span>
